/* eslint-disable react/prop-types */
import React, { useEffect, useState, useRef, useContext } from "react";
import { Row, Col, Button, InputGroup, Modal, Spinner } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { useHistory } from "react-router";
import API from '../../Utility';
import { ProjectContext } from "../../ProjectContext";

export default function DuplicateWorkflowFormModal(props) {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  let history = useHistory();

  const { project } = useContext(ProjectContext);
  useEffect(() => {
    async function initializeData() {
      setIsLoading(true);
      const duplicate = await API.post({
        url: `/admin/${project._id}/workflows/${props.workflow._id}/duplicate`,
        data: {
          workflow: props.workflow
        }
      });
      if (duplicate?._id) {
        setIsLoading(false);
        props.onSuccess(duplicate);
        history.push(`/workflows/${project._id}/${duplicate._id}`);
      } else {
        setIsLoading(false);
        setError('Something went wrong while duplicating the workflow. Please try again later.');
      }
    }
    if (props.show) {
      initializeData();
    }
  }, [props.show]);
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      scrollable
      title=""
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Duplicate Workflow
        </Modal.Title>
      </Modal.Header>
      <>
        <Modal.Body>
          {isLoading && !error?.length ? 'Please hold on while we duplicate the workflow, including all its milestones, tasks, and roles. Once the process is complete, you will be redirected to the new workflow.' : ''}
          {error?.length > 0 ? error : ''}
        </Modal.Body>
        <Modal.Footer>
          {!isLoading ? (
            <div style={{ width: "100%", display: "flex", alignItems: "flex-end", justifyContent: "flex-end" }}>
              <Button
                onClick={(e) => props.onCancel(e, true)}
                variant="outline-primary"
              >
              Close
              </Button>
            </div>
          ) : (
            <Spinner animation="border" role="status">
              <span className="sr-only">Duplicating workflow...</span>
            </Spinner>
          )}
        </Modal.Footer>
      </>
    </Modal>
  );
}
